<template>
  <v-container text-xs-center>
    <v-data-table
      :headers="headers"
      :items="results"
      :search="search"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      @page-count="pageCount = $event"
      :hide-default-header="isMobile"
      :class="{ mobile: isMobile }"
      class="elevation-5"
      sort-by="node.resultDate"
      sort-desc
      :loading="loadingTable"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.node.set.distance`]="{ item }">
        <v-chip small class="p-2">{{ getItemDistance(item) }}</v-chip>
      </template>
      <template v-slot:[`item.node.place`]="{ item }">
        <v-icon
          v-if="item.node.place > 0 && item.node.place <= 3"
          :color="getMedalColor(item.node.place)"
          class="mr-2"
        >
          fas fa-medal
        </v-icon>
        <span>{{ item.node.place }}</span>
      </template>
      <template v-slot:top>
        <BaseToolbar toolbarTitle="Athlete Results">
          <template v-slot:toolbarSearch>
            <v-text-field
              v-model="search"
              outlined
              dense
              append-icon="search"
              label="Search"
              class="mb-5 mb-sm-0"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </template>
          <template v-slot:toolbarBtn>
            <v-autocomplete
              v-model="athleteId"
              required
              hide-details
              outlined
              dense
              :hint="`${athleteId}`"
              label="Select Athlete Name"
              :items="getAthletes"
              item-value="athleteId"
              :item-text="text"
            >
            </v-autocomplete>
          </template>
        </BaseToolbar>
        <SecondToolbar>
          <template v-slot:toolbarContent>
            <v-select
              v-model="gender"
              hide-details
              clearable
              outlined
              class="mt-3"
              dense
              :items="['male', 'female']"
              label="Gender"
            ></v-select>
            <DateRange
              class="mt-6"
              @change-fromDate="fromDate = $event"
              @change-toDate="toDate = $event"
            />
            <v-checkbox
              v-model="medals"
              :color="medals ? 'blue' : 'grey'"
              :label="$vuetify.breakpoint.smAndUp ? 'Medals Only' : ''"
              on-icon="fas fa-medal"
              off-icon="fas fa-medal"
              hide-details
              class="mt-3 hidden-xs-only"
            ></v-checkbox>
          </template>
        </SecondToolbar>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import BaseToolbar from "@/components/base/BaseToolbar.vue";
import DateRange from "@/components/shared/date_range_from_to.vue";
import SecondToolbar from "@/components/base/BaseToolbarV2.vue";

export default {
  components: { BaseToolbar, DateRange, SecondToolbar },
  name: "home",
  data() {
    return {
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      search: "",
      athleteId: "",
      loadingTable: true,
      isMobile: false,
      medals: false,
      fromDate: "2017-03-13",
      toDate: new Date().toISOString().substr(0, 10),
      gender: null,
      menu: false,
      menu1: false,
      pagination: {
        rowsPerPage: 15
      },
      headers: [
        {
          text: "Athlete Name",
          align: "left",
          sortable: true,
          value: "node.athlete.firstName"
        },
        { text: "Athlete Name", value: "node.athlete.lastName" },
        { text: "Event", value: "node.set.distance" },
        { text: "ResultDate", value: "node.resultDate" },
        { text: "ResultTime", value: "node.resultTime" },
        { text: "Place", value: "node.place" },
        { text: "Meet", value: "node.meet.meetName" }
        //  { text: "Actions", value: "node.name", sortable: false }
      ]
    };
  },
  async created() {
    await this.$store
      .dispatch("allResults", {
        clubId: this.$route.params.club
      })
      .then(() => {
        this.loadingTable = false;
      })
      .catch(error => {
        this.loadingTable = false;
        console.error(error);
      });
    if (this.clubInfo.edges) {
      this.$route.params.club = this.clubInfo.edges[0].node.clubId;
    }
    //Distructing the object into variables
    // eslint-disable-next-line
    const { page } = this.$route.query;
  },
  mounted() {
    console.log(this.$route);
  },
  computed: {
    ...mapGetters(["loading", "athleteResults", "clubInfo", "clubs"]),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    dialog() {
      return false;
    },
    results() {
      if (this.athleteResults.edges) {
        return this.athleteResults.edges.filter(
          item =>
            (!this.medals || (item.node.place > 0 && item.node.place <= 3)) &&
            (!this.gender || item.node.athlete.gender == this.gender) &&
            (!this.athleteId || item.node.athleteId == this.athleteId)
        );
      } else {
        return [];
      }
    },

    getAthletes() {
      if (this.athleteResults.edges) {
        return [
          ...new Set(this.athleteResults.edges.map(item => item.node.athleteId))
        ].map(id => {
          const info = this.athleteResults.edges.find(
            el => +el.node.athleteId === +id
          );
          if (info.node) {
            return {
              athleteId: id,
              firstName: info.node.athlete.firstName,
              lastName: info.node.athlete.lastName
            };
          } else {
            console.warn(`In getAthlete method no athletes.`);
            return {};
          }
        });
      } else {
        console.warn("no data in athleteResults.edges");
        return [];
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    "$route.params.club": async function(val) {
      console.log(val);
      await this.$store
        .dispatch("allResults", {
          clubId: this.$route.params.club
        })
        .then(() => {
          this.loadingTable = false;
        })
        .catch(error => {
          this.loadingTable = false;
          console.error(error);
        });
    },
    "clubInfo.edges.0.node.clubId"(val) {
      const currentClub = this.$route.params.club;
      if (val && val !== currentClub) {
        this.$router.replace({
          name: this.$route.name, // stay on same component
          params: { ...this.$route.params, club: val },
          query: { tab: this.$route.query.tab }
        });
      }
    }
  },

  methods: {
    text: item => item.firstName + " " + item.lastName,
    getItemDistance: i =>
      i.node.set ? i.node.set.distance + " " + i.node.set.stroke : "No Data",
    //  customSort(items, index, isDescending) {
    //       // The following is informations as far as I researched.
    //       // items: 'food' items
    //       // index: Enabled sort headers value. (black arrow status).
    //       // isDescending: Whether enabled sort headers is desc
    //       items.sort((a, b) => {
    //           if (index === 'resultDate') {
    //               if (isDescending) {
    //                   return b.resultDate - a.resultDate;
    //               } else {
    //                   return a.resultDate - b.resultDate;
    //               }
    //           }
    //       });

    //       return items;
    //     },
    getMedalColor(level) {
      var tagcolor = "";
      switch (level) {
        case 1:
          tagcolor = "#FFD700";
          break;
        case 2:
          tagcolor = "#C0C0C0";
          break;
        case 3:
          tagcolor = "#CD7F32";
          break;
        default:
          tagcolor = "grey";
      }
      return tagcolor;
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },

    editItem(item) {
      this.editedIndex = this.handleGetAthleteResults.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.handleGetAthleteResults.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.handleGetAthleteResults.splice(index, 1);
    },

    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>
<style lang="scss"></style>